var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAlertColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 100 100"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 34.807,
  cy: 34.808,
  r: 34,
  fill: "#de5b6b"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 9.752,
  strokeMiterlimit: 10,
  d: "M34.807 14.035v25.916m0 5.324v7.723"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h69.614v69.614H0z"
})));
export default SvgIconAlertColor;